import React, { useState, useEffect } from 'react';
import { throttle } from '../../utils/throttle';

const SearchBar = ({
  searchText,
  onclickHandle,
  showClearIcon,
  onSearchChangeHandle,
  placeholder,
  searchIcon,
}) => {
  const [isScrolled, setIsScrolled] = useState(false);
  const inputRef = React.createRef();

  useEffect(() => {
    inputRef.current && inputRef.current.focus();
    window.addEventListener('scroll', throttle(handleScroll, 500), { passive: true });
    return () => {
      window.removeEventListener('scroll', handleScroll, 500);
    };
  }, []);

  const handleScroll = () => {
    if (window.pageYOffset >= 200) {
      setIsScrolled(true);
    } else if (window.pageYOffset < 200) {
      setIsScrolled(false);
    }
  };

  const onClearSearch = () => {
    onSearchChangeHandle('');
  };

  return (
    <div className={`ds-searchbar-wrapper ${isScrolled ? 'searchbar-fixed' : ''}`}>
      <div className={`searchbar`} onClick={onclickHandle}>
        <img
          loading="lazy"
          className="searchbar-icon"
          src={searchIcon || 'https://cdn.dotpe.in/longtail/themes/8073865/m16oxop3.webp'}
          alt="Search bar icon"
        />
        <input
          ref={inputRef}
          className="searchbar-input"
          value={searchText}
          onChange={(e) => onSearchChangeHandle(e.target.value)}
          placeholder={placeholder ? placeholder : ''}
        />

        {showClearIcon && (
          <span className="searchbar-closeicon" onClick={onClearSearch}>
            <img
              loading="lazy"
              src="https://cdn.dotpe.in/longtail/themes/8073865/9sE359Sh.webp"
              alt="cancel icon"
            />
          </span>
        )}
      </div>
    </div>
  );
};

export default SearchBar;
